import { render, staticRenderFns } from "./my_commodity.vue?vue&type=template&id=4f282a18&scoped=true"
import script from "./my_commodity.vue?vue&type=script&lang=js"
export * from "./my_commodity.vue?vue&type=script&lang=js"
import style0 from "./my_commodity.vue?vue&type=style&index=0&id=4f282a18&prod&lang=scss"
import style1 from "./my_commodity.vue?vue&type=style&index=1&id=4f282a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f282a18",
  null
  
)

export default component.exports